/**
 * The game does not zoom (owner, 2026-10-19). The viewport rule in index.html covers most browsers; iOS Safari ignores it,
 * so pinch gestures are cancelled here too. Players who need bigger text use the "Larger text" setting.
 * Single-finger moves are left alone so scrolling inside sheets keeps working.
 */
export function installZoomLock(doc: Document): () => void {
  const stopGesture = (event: Event) => event.preventDefault();
  const stopPinch = (event: Event) => {
    const touches = (event as Event & { touches?: ArrayLike<unknown> }).touches;
    if (touches && touches.length > 1) event.preventDefault();
  };
  doc.addEventListener("gesturestart", stopGesture);
  doc.addEventListener("gesturechange", stopGesture);
  doc.addEventListener("touchmove", stopPinch, { passive: false });
  return () => {
    doc.removeEventListener("gesturestart", stopGesture);
    doc.removeEventListener("gesturechange", stopGesture);
    doc.removeEventListener("touchmove", stopPinch);
  };
}
